import React, {useContext} from "react";
import DynamicAddButton from "../DynamicAddButton";
import CheckoutLink from "./CheckoutLink";

import FreeShippingIndicator from "../FreeShippingIndicator";

export default function ItemCartBox({
  sectionConfig={},
  application, product, cartItem, shoppingCart,
  ...props
}) {
  const { regularPriceCents } = product;

  let price = regularPriceCents && new Money(regularPriceCents);

  return <div className="cart-box text-left lg:text-right">
    {price && <div className="text-2xl text-brand-primary">{price.toString()}</div> }
    <FreeShippingIndicator priceCents={regularPriceCents} />

    <DynamicAddButton
      className="text-2xl w-full bg-brand-primary text-anti-primary py-2 cursor-pointer hover:opacity-75"
      application={application}
      product={product}
      cartItem={cartItem}
    />

    {cartItem && <CheckoutLink shoppingCart={shoppingCart} />}
  </div>
}


